import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import Vue from 'vue';
import DarkMixin from "../../mixins/dark.js";
import { getSizeMixin } from "../../mixins/size.js";
import ListenersMixin from "../../mixins/listeners.js";
import { mergeSlot } from "../../utils/slot.js";

function width(val, reverse, $q) {
  return {
    transform: reverse === true ? "translateX(".concat($q.lang.rtl === true ? '-' : '', "100%) scale3d(").concat(-val, ",1,1)") : "scale3d(".concat(val, ",1,1)")
  };
}

export default Vue.extend({
  name: 'QLinearProgress',
  mixins: [ListenersMixin, DarkMixin, getSizeMixin({
    xs: 2,
    sm: 4,
    md: 6,
    lg: 10,
    xl: 14
  })],
  props: {
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    instantFeedback: Boolean
  },
  computed: {
    motion: function motion() {
      return this.indeterminate === true || this.query === true;
    },
    widthReverse: function widthReverse() {
      return this.reverse !== this.query;
    },
    classes: function classes() {
      return 'q-linear-progress' + (this.color !== void 0 ? " text-".concat(this.color) : '') + (this.reverse === true || this.query === true ? ' q-linear-progress--reverse' : '') + (this.rounded === true ? ' rounded-borders' : '');
    },
    trackStyle: function trackStyle() {
      return width(this.buffer !== void 0 ? this.buffer : 1, this.widthReverse, this.$q);
    },
    trackClass: function trackClass() {
      return "q-linear-progress__track--with".concat(this.instantFeedback === true ? 'out' : '', "-transition") + " q-linear-progress__track--".concat(this.isDark === true ? 'dark' : 'light') + (this.trackColor !== void 0 ? " bg-".concat(this.trackColor) : '');
    },
    modelStyle: function modelStyle() {
      return width(this.motion === true ? 1 : this.value, this.widthReverse, this.$q);
    },
    modelClasses: function modelClasses() {
      return "q-linear-progress__model--with".concat(this.instantFeedback === true ? 'out' : '', "-transition") + " q-linear-progress__model--".concat(this.motion === true ? 'in' : '', "determinate");
    },
    stripeStyle: function stripeStyle() {
      return {
        width: this.value * 100 + '%'
      };
    },
    stripeClass: function stripeClass() {
      return this.reverse === true ? 'absolute-right' : 'absolute-left';
    },
    attrs: function attrs() {
      return {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 1,
        'aria-valuenow': this.indeterminate === true ? void 0 : this.value
      };
    }
  },
  render: function render(h) {
    var child = [h('div', {
      staticClass: 'q-linear-progress__track absolute-full',
      style: this.trackStyle,
      class: this.trackClass
    }), h('div', {
      staticClass: 'q-linear-progress__model absolute-full',
      style: this.modelStyle,
      class: this.modelClasses
    })];
    this.stripe === true && this.motion === false && child.push(h('div', {
      staticClass: 'q-linear-progress__stripe',
      style: this.stripeStyle,
      class: this.stripeClass
    }));
    return h('div', {
      style: this.sizeStyle,
      class: this.classes,
      attrs: this.attrs,
      on: _objectSpread({}, this.qListeners)
    }, mergeSlot(child, this, 'default'));
  }
});